import { ConfigProvider, theme as antTheme } from "antd";
import { createContext, ReactNode, useContext, useState } from "react";
import { ThemeProvider } from "styled-components";

import { Moon01, Sun02 } from "@sol/uikit/core/icons";
import { Switch } from "@sol/uikit/data-entry/Switch";
import { themeConfig } from "@sol/uikit/theming";

export { GlobalStyle } from "@sol/uikit/theming";

import theme from "../../uikit/theme";

type AppThemeProviderProps = {
    darkMode?: boolean;
    children: ReactNode;
};
export function AppThemeProvider({ children, darkMode }: AppThemeProviderProps) {
    const [enableDarkMode, setEnableDarkMode] = useState(darkMode ?? false);

    const isDark = darkMode ?? enableDarkMode;

    return (
        <darkModeCtx.Provider value={{ darkMode: isDark, setDarkMode: setEnableDarkMode }}>
            <ConfigProvider theme={isDark ? { ...themeConfig, algorithm: antTheme.darkAlgorithm } : themeConfig}>
                <ThemeProvider theme={theme}>{children}</ThemeProvider>
            </ConfigProvider>
        </darkModeCtx.Provider>
    );
}

const darkModeCtx = createContext<{ darkMode: boolean; setDarkMode: (darkMode: boolean) => void }>({
    darkMode: false,
    setDarkMode: () => {},
});

export function DarkModeSwitch() {
    const { darkMode, setDarkMode } = useContext(darkModeCtx);
    return (
        <Switch
            checked={darkMode}
            onChange={setDarkMode}
            size="default"
            checkedChildren={
                <span className="flex h-[var(--ant-switch-track-height)] items-center">
                    <Moon01 variant="antd" />
                </span>
            }
            unCheckedChildren={
                <span className="flex h-[var(--ant-switch-track-height)] items-center">
                    <Sun02 variant="antd" />
                </span>
            }
        />
    );
}
